import { render, staticRenderFns } from "./AttachmentTable.vue?vue&type=template&id=798cad9e&"
import script from "@/components/AttachmentTable/AttachmentTable.ts?vue&type=script&lang=ts&"
export * from "@/components/AttachmentTable/AttachmentTable.ts?vue&type=script&lang=ts&"
import style0 from "@/components/AttachmentTable/attachment-table.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
